export default function toggleSearch () {
    document.addEventListener('click', (event) => {
        const trigger = event.target.closest('.js-search-toggle');
        if (!trigger) return;

        event.preventDefault();

        trigger.nextElementSibling?.classList.toggle('is-active');
    });
}